"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALIDATION_STATUS = {
    required: 'required',
    valid: 'valid',
    incomplete: 'incomplete',
};
exports.VALIDATION_PATTERN = {
    uppercase: /^[A-Z]/g,
    lowercase: /[a-z]/g,
    alphanumeric: /^[a-zA-Z0-9]*$/g,
    number: /^[0-9]*$/g,
    realNumber: /^[0-9]*\\.?[0-9]*$/g,
    currencyAmount: /^([0-9]*\\.[0-9]{1,2}|[0-9]*)$/g,
    numberNotZero: /^[1-9]\\d*$/g,
    noNumber: /^([^0-9]*)$/g,
    noUppercase: /^([^A-Z]*)$/g,
    noLowercase: /^([^a-z]*)$/g,
    ascii: /^[\x00-\x7f]+$/g,
    email: /^(([A-Za-z0-9]+_+)|([A-Za-z0-9]+\-+)|([A-Za-z0-9]+\.+)|([A-Za-z0-9]+\++))*[A-Za-z0-9]+@((\w+\-+)|(\w+\.))*\w{1,63}\.[a-zA-Z]{2,6}$/g,
    email2: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g,
    username: /^([^\\s]+)$/g,
    passwordSpecialChars: /^[$@!%*?&()~;:_+=.]/g,
    passwordAllowedChars: /^([a-zA-Z0-9!=+_$:;^/()~?.¬%*]*)$/g,
    weakPassword: /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])[a-zA-Z0-9!=+_$:;^\/()~?.¬%*]{8,}$/g,
    mediumPassword: /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[$&+,:;=?@#|\'<>.^*()%!-])[a-zA-Z0-9!=+_$:;^\/()~?.¬%*]{8,}$/g,
    strongPassword: /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[$&+,:;=?@#|\'<>.^*()%!-])[a-zA-Z0-9!=+_$:;^\/()~?.¬%*]{10,}$/g,
};
